import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BridgeComponent } from "../bridge.component";
import { FE_Webhook } from "@shared/models/webhooks";
import { WebhooksApiService } from "@shared/services/integrations/webhooks-api.service";
import { ScalarClientApiService } from "@shared/services/scalar/scalar-client-api.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { ConfigScreenBridgeComponent } from "../config-screen/config-screen.bridge.component";
import { FormsModule } from "@angular/forms";
import { FieldComponent } from "../../../elements/field/field.component";
import { LogService } from "@shared/services/log.service";


interface WebhooksConfig {
    webhooks: FE_Webhook[];
    botUserId: string;
}

@Component({
    selector: "my-webhooks-bridge-config",
    templateUrl: "webhooks.bridge.component.html",
    styleUrls: ["webhooks.bridge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenBridgeComponent, FormsModule, FieldComponent, TranslatePipe]
})
export class WebhooksBridgeConfigComponent extends BridgeComponent<WebhooksConfig> {

    public webhookName: string;
    public isBusy = false;

    constructor(private readonly webhooks: WebhooksApiService, private readonly scalar: ScalarClientApiService, public translate: TranslateService,
        logService: LogService,
    ) {
        super("webhooks", translate, logService);
    }

    public async newHook() {
        this.isBusy = true;

        try {
            await this.scalar.inviteUser(this.roomId, this.newConfig.botUserId);
        } catch (e) {
            if (!e.response?.error?._error?.message?.includes("already in the room")) {
                this.isBusy = false;
                this.translate.get('Error inviting bridge').subscribe((res: string) => {
                    this.toaster.pop("error", res);
                });
                return;
            }
        }

        this.webhooks.createWebhook(this.roomId, {label: this.webhookName}).then(hook => {
            this.newConfig.webhooks.push(hook);
            this.isBusy = false;
            this.webhookName = "";
            this.translate.get('Webhook created').subscribe((res: string) => {
                this.toaster.pop("success", res);
            });
        }).catch(err => {
            this.logService.error(err);
            this.isBusy = false;
            this.translate.get('Error creating webhook').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }

    public removeHook(hook: FE_Webhook) {
        this.isBusy = true;
        this.webhooks.deleteWebhook(this.roomId, hook.id).then(() => {
            const idx = this.newConfig.webhooks.indexOf(hook);
            if (idx !== -1) this.newConfig.webhooks.splice(idx, 1);
            this.isBusy = false;
            this.translate.get('Webhook deleted').subscribe((res: string) => {
                this.toaster.pop("success", res);
            });
        }).catch(err => {
            this.logService.error(err);
            this.isBusy = false;
            this.translate.get('Error deleting webhook').subscribe((res: string) => {
                this.toaster.pop("error", res);
            });
        });
    }
}
